import moment from "moment";
import { incidentRelatedLists } from "../helpers/relatedListHelpers";

export function _getRLValues(incidentObject: any) {
  let relatedListValues: { [x: string]: any[] } = {};
  Object.keys(incidentRelatedLists).forEach((key: string) => {
    relatedListValues[incidentRelatedLists[key]] = Array.isArray(
      incidentObject[key]
    )
      ? incidentObject[key]
      : [incidentObject[key]];
  });
  return relatedListValues;
}

export function transformDraftIncidentData(draftIncident: any) {
  if (!draftIncident) return;
  let incidentDetails;
  try {
    const transformedIncidentDetails = JSON.parse(
      draftIncident.Incident_Json__c
    );
    incidentDetails = {
      ...transformedIncidentDetails.incident,
      ..._getRLValues(transformedIncidentDetails),
      Id: draftIncident?.Id,
    };
    return {
      ...incidentDetails,
      CreatedAtDate: draftIncident?.CreatedDate
        ? moment(draftIncident?.CreatedDate).format("DD MMM YYYY")
        : "-",
      incidentCreatedBy: incidentDetails?.Draft_Created_By__c || " - ",
    };
  } catch (error: any) {
    console.error("Parsing error:", error?.message);
  }
}
